const withHeaders = <R>(handler: (headers: Headers) => R): R => {
  const { headers } = require('next/headers');
  return handler(headers());
};

export default withHeaders;
